import React from 'react';
import PropTypes from 'prop-types';

import { useSingleSiteSetting } from 'common/react/hooks/use-single-site-setting';
import { SiteSettingsModal } from '../components/SiteSettingsModal';

export const SiteSettingsModalWrapper = ({ regionsPage }) => {
    const modalType = useSingleSiteSetting('modalType');

    return modalType !== null ? (
        <SiteSettingsModal modalType={modalType} regionsPage={regionsPage} />
    ) : null;
};

SiteSettingsModalWrapper.propTypes = {
    regionsPage: PropTypes.string.isRequired
};
